import React, { useState } from "react"
import {graphql, useStaticQuery} from "gatsby"
import EloCareerTable from "../helper_js/elo_career_table"
import Creatable from 'react-select'
import { components } from "react-select"


import statStyles from './era_adj_elo.module.scss'

const EraAdjElo = () => {

    const data = useStaticQuery(graphql`
        query {
            allEraAdjQbNamesCsv {
                nodes {
                    qb_name
                }
            }
        }
    `)

    const dropOptions = data.allEraAdjQbNamesCsv.nodes.map((row) => {
        return (
            {'value' : row['qb_name'], 'label' : row['qb_name']}
        )
    })

    // https://stackoverflow.com/questions/55119120/how-to-set-max-number-of-items-that-can-be-selected-in-react-select
    const Menu = props => {
        const optionSelectedLength = props.getValue().length || 0;
        return (
          <components.Menu {...props}>
            {optionSelectedLength < 5 ? (
              props.children
            ) : (
              <div style={{ margin: 15 }}>Max limit achieved</div>
            )}
          </components.Menu>
        );
      };

    const isValidNewOption = (inputValue, selectValue) =>
        inputValue.length > 0 && selectValue.length < 5;

    const [qbs, setQbs] = useState(['Tom Brady', 'Peyton Manning'])


    return(
        <div className={statStyles.career_wrapper}>
            <h2 className={statStyles.section_header}>
                About QB Elo
            </h2>
            <div className={statStyles.about_div}>
                <p className={statStyles.about_text}>
                    QB Elo Value is a measure and prediction of QB value from 538's Elo model. It uses traditional stats (yards, completions, TDs, etc) to model ESPN's QBR then normalizes that value to be on the same scale as the Elo model. Think of QB Elo Value as QBR, but not on a 0-100 scale.
                </p>
                <p className={statStyles.about_text}>
                    Cummulative QB Elo Value is the sum of a QB's performance across their career (Elo / Game * number of games). This number is a great way to quantify the total value a QB contributed across their career.
                </p>
                <p className={statStyles.about_text}>
                    Because passing stats have inflated overtime, making comparisons across era require us to adjust the Elo numbers. This is done by looking at QB's Elo value in a given week relative to the league average QB performance at that point of time. You can read more about this methodology <a href='https://www.opensourcefootball.com/posts/2020-08-22-ranking-qbs-using-era-adjusted-elo/'>here</a>.
                </p>
            </div>
            <div className={statStyles.drop_wrapper}>
                <Creatable
                    options={dropOptions}
                    components={{ Menu }}
                    isValidNewOption={isValidNewOption}
                    placeholder='Select QBs'
                    isSearchable
                    isMulti
                    onChange={setQbs}
                />
            </div>
            <EloCareerTable
                qbs={qbs}
            />
        </div>
    )

}

export default EraAdjElo